import { clomp } from 'clomp';

export const Base = clomp.footer`
  text-center

  lg:text-right
`;
